import React from "react"
import DailyActivityLevelStyle from "./DailyActivityLevelStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const DailyActivityLevel = ({
  dailyActivity,
  handleChangeDailyActivity,
  locale,
}) => {
  return (
    <div className={DailyActivityLevelStyle.holder}>
      <p className={DailyActivityLevelStyle.daily_title}>
        6.{" "}
        {translate(
          keys.WHICH_SENTENCE_BEST_DESCRIBES_YOUR_DAILY_ACTIVITY_LEVEL,
          locale
        )}
      </p>
      <div className={DailyActivityLevelStyle.units}>
        <label
          htmlFor="seated"
          className={
            dailyActivity === "seated"
              ? DailyActivityLevelStyle.active_unit
              : DailyActivityLevelStyle.unit_holder
          }
        >
          <input
            id="seated"
            type="radio"
            value="seated"
            checked={dailyActivity === "seated"}
            onChange={handleChangeDailyActivity}
          />
          {translate(keys.SEATED_MOST_OF_THE_DAY, locale)}
        </label>
        <label
          htmlFor="standing"
          className={
            dailyActivity === "standing"
              ? DailyActivityLevelStyle.active_unit
              : DailyActivityLevelStyle.unit_holder
          }
        >
          <input
            id="standing"
            type="radio"
            value="standing"
            checked={dailyActivity === "standing"}
            onChange={handleChangeDailyActivity}
          />
          {translate(keys.STANDING_ABOUT_HALF_THE_TIME, locale)}
        </label>
        <label
          htmlFor="walking"
          className={
            dailyActivity === "walking"
              ? DailyActivityLevelStyle.active_unit
              : DailyActivityLevelStyle.unit_holder
          }
        >
          <input
            id="walking"
            type="radio"
            value="walking"
            checked={dailyActivity === "walking"}
            onChange={handleChangeDailyActivity}
          />
          {translate(keys.WALKING_ABOUT_HALF_THE_TIME, locale)}
        </label>
        <label
          htmlFor="moving"
          className={
            dailyActivity === "moving"
              ? DailyActivityLevelStyle.active_unit
              : DailyActivityLevelStyle.unit_holder
          }
        >
          <input
            id="moving"
            type="radio"
            value="moving"
            checked={dailyActivity === "moving"}
            onChange={handleChangeDailyActivity}
          />
          {translate(keys.CONSTANTLY_ON_THE_MOVE, locale)}
        </label>
      </div>
    </div>
  )
}

export default DailyActivityLevel
